<template>
  <div class="intent-verify-slip-box">
    <v-tabs
      v-model="currentTab"
      color="white"
      @change="handleChangeTab"
      :slider-color="$vuetify.theme.primary"
      :show-arrows="false"
    >
      <v-tab ripple :key="'correct'" :href="'#correct'">
        {{ $t('verify_slip_correct') }}
      </v-tab>

      <v-tab ripple :key="'incorrect'" :href="'#incorrect'">
        {{ $t('verify_slip_incorrect') }}
      </v-tab>

      <v-tab ripple :key="'error'" :href="'#error'">
        {{ $t('verify_slip_error') }}
      </v-tab>
      <v-tab ripple :key="'duplicate'" :href="'#duplicate'">
        {{ $t('verify_slip_duplicate') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item :key="1" :value="'correct'">
        <message-viewer v-model="correctMsg" :channel="channel" v-if="readonly"></message-viewer>
        <intent-group-item
          v-model="correctMsg"
          class="intent-group-item"
          :isIgType="isIgType"
          :isWelcome="isWelcome"
          :isBroadCast="isBroadCast"
          :indexAlternative="indexAlternative"
          :intentname="intentname"
          :channel="channel"
          :availableBubbles="availableBubbles"
          :isHasPrefill="isHasPrefill"
          :followUp="followUp"
          :isBeacon="isBeacon"
          :isIntent="isIntent"
          :messagesType="messagesType"
          :maxLength="maxLength"
          :isNotAltText="isNotAltText"
          :isNotRatio="isNotRatio"
          :groupType="groupType"
          :customType="customType"
          :isLineShopping="isLineShopping"
          :isAdsPreview="isAdsPreview"
          :isFirstAnnouncement="isFirstAnnouncement"
          :isVerifySlip="isVerifySlip"
          :isRenderText="!isLoading"
          v-else
        ></intent-group-item>
        <!-- <intent-verify-slip-item
          v-model="correctMsg"
          type="correct"
          :errors="errors"
          :isLineShopping="isLineShopping"
          :channel="channel"
          :index="index"
          :indexAlternative="indexAlternative"
          v-else
        ></intent-verify-slip-item> -->
      </v-tab-item>
      <v-tab-item :key="2" :value="'incorrect'">
        <message-viewer v-model="incorrectMsg" :channel="channel" v-if="readonly"></message-viewer>
        <intent-group-item
          v-model="incorrectMsg"
          class="intent-group-item"
          :isIgType="isIgType"
          :isWelcome="isWelcome"
          :isBroadCast="isBroadCast"
          :indexAlternative="indexAlternative"
          :intentname="intentname"
          :channel="channel"
          :availableBubbles="availableBubbles"
          :isHasPrefill="isHasPrefill"
          :followUp="followUp"
          :isBeacon="isBeacon"
          :isIntent="isIntent"
          :messagesType="messagesType"
          :maxLength="maxLength"
          :isNotAltText="isNotAltText"
          :isNotRatio="isNotRatio"
          :groupType="groupType"
          :customType="customType"
          :isLineShopping="isLineShopping"
          :isAdsPreview="isAdsPreview"
          :isFirstAnnouncement="isFirstAnnouncement"
          :isVerifySlip="isVerifySlip"
          :isRenderText="!isLoading"
          v-else
        ></intent-group-item>
        <!-- <intent-verify-slip-item
          v-model="incorrectMsg"
          type="incorrect"
          :errors="errors"
          :isLineShopping="isLineShopping"
          :channel="channel"
          :index="index"
          :indexAlternative="indexAlternative"
          v-else
        ></intent-verify-slip-item> -->
      </v-tab-item>
      <v-tab-item :key="3" :value="'error'">
        <message-viewer v-model="errMsg" :channel="channel" v-if="readonly"></message-viewer>
        <intent-group-item
          v-model="errMsg"
          class="intent-group-item"
          :isIgType="isIgType"
          :isWelcome="isWelcome"
          :isBroadCast="isBroadCast"
          :indexAlternative="indexAlternative"
          :intentname="intentname"
          :channel="channel"
          :availableBubbles="availableBubbles"
          :isHasPrefill="isHasPrefill"
          :followUp="followUp"
          :isBeacon="isBeacon"
          :isIntent="isIntent"
          :messagesType="messagesType"
          :maxLength="maxLength"
          :isNotAltText="isNotAltText"
          :isNotRatio="isNotRatio"
          :groupType="groupType"
          :customType="customType"
          :isLineShopping="isLineShopping"
          :isAdsPreview="isAdsPreview"
          :isFirstAnnouncement="isFirstAnnouncement"
          :isVerifySlip="isVerifySlip"
          :isRenderText="!isLoading"
          v-else
        ></intent-group-item>
        <!-- <intent-verify-slip-item
          v-model="errMsg"
          type="error"
          :errors="errors"
          :isLineShopping="isLineShopping"
          :channel="channel"
          :index="index"
          :indexAlternative="indexAlternative"
          v-else
        ></intent-verify-slip-item> -->
      </v-tab-item>
      <v-tab-item :key="4" :value="'duplicate'">
        <message-viewer v-model="duplicateMsg" :channel="channel" v-if="readonly"></message-viewer>
        <intent-group-item
          v-model="duplicateMsg"
          class="intent-group-item"
          :isIgType="isIgType"
          :isWelcome="isWelcome"
          :isBroadCast="isBroadCast"
          :indexAlternative="indexAlternative"
          :intentname="intentname"
          :channel="channel"
          :availableBubbles="availableBubbles"
          :isHasPrefill="isHasPrefill"
          :followUp="followUp"
          :isBeacon="isBeacon"
          :isIntent="isIntent"
          :messagesType="messagesType"
          :maxLength="maxLength"
          :isNotAltText="isNotAltText"
          :isNotRatio="isNotRatio"
          :groupType="groupType"
          :customType="customType"
          :isLineShopping="isLineShopping"
          :isAdsPreview="isAdsPreview"
          :isFirstAnnouncement="isFirstAnnouncement"
          :isVerifySlip="isVerifySlip"
          :isRenderText="!isLoading"
          v-else
        ></intent-group-item>
        <!-- <intent-verify-slip-item
          v-model="errMsg"
          type="error"
          :errors="errors"
          :isLineShopping="isLineShopping"
          :channel="channel"
          :index="index"
          :indexAlternative="indexAlternative"
          v-else
        ></intent-verify-slip-item> -->
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import IntentVerifySlipItem from './IntentVerifySlipItem.vue'
import IntentGroupItem from './IntentGroupItem.vue'
import MessageViewer from '@/components/elements/MessageViewer'

export default {
  components: {
    IntentVerifySlipItem,
    IntentGroupItem,
    MessageViewer
  },
  data: () => ({
    currentTab: 'correct',
    isLoading: true
  }),
  props: {
    correct: {
      type: [String, Array],
      default: () => ''
    },
    incorrect: {
      type: [String, Array],
      default: () => ''
    },
    err: {
      type: [String, Array],
      default: () => ''
    },
    duplicate: {
      type: [String, Array],
      default: () => ''
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isIgType: {
      type: Boolean,
      default: () => false
    },
    isWelcome: {
      type: Boolean,
      default: () => false
    },
    isBroadCast: {
      type: Boolean,
      default: () => false
    },
    indexAlternative: {
      type: Number,
      default: () => 0
    },
    intentname: {
      type: String,
      default: () => ''
    },
    channel: {
      type: String,
      default: () => ''
    },
    availableBubbles: {
      type: Array
    },
    isHasPrefill: {
      type: Boolean,
      default: () => false
    },
    followUp: {
      type: Boolean,
      default: () => false
    },
    isBeacon: {
      type: Boolean,
      default: () => false
    },
    isIntent: {
      type: Boolean,
      default: () => false
    },
    messagesType: {
      type: String,
      default: () => ''
    },
    maxLength: {
      type: [Number, String],
      default: () => null
    },
    isNotAltText: {
      type: Boolean,
      default: () => false
    },
    isNotRatio: {
      type: Boolean,
      default: () => false
    },
    groupType: {
      type: String,
      default: () => ''
    },
    customType: {
      type: String,
      default: () => ''
    },
    isLineShopping: {
      type: Boolean,
      default: () => false
    },
    isAdsPreview: {
      type: Boolean,
      default: () => false
    },
    isFirstAnnouncement: {
      type: Boolean,
      default: () => false
    },
    isVerifySlip: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    correctMsg: {
      get() {
        return this.correct
      },
      set(value) {
        this.$emit('update:correct', value)
      }
    },
    incorrectMsg: {
      get() {
        return this.incorrect
      },
      set(value) {
        this.$emit('update:incorrect', value)
      }
    },
    errMsg: {
      get() {
        return this.err
      },
      set(value) {
        this.$emit('update:err', value)
      }
    },
    duplicateMsg: {
      get() {
        return this.duplicate
      },
      set(value) {
        this.$emit('update:duplicate', value)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isLoading = false
    })
  },
  methods: {
    handleChangeTab(tab) {
      this.isLoading = true
      this.$nextTick(() => {
        this.isLoading = false
        this.currentTab = tab
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-box-verify-slip {
  float: left;
  max-width: 240px;
  overflow-wrap: break-word;
  min-height: 22px;
  min-width: 14px;
  line-height: 15.36px;
  overflow: hidden;
  cursor: pointer;
  font-size: 12px;
  color: black;
}

.form-control-wrapper {
  border-radius: 12px;
  padding: 8px 6px 2px;
  background-color: #f1f0f0;
}

.intent-group-item {
  transition: height ease 2s;
  -webkit-transition: height ease 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentVerifySlip.vue